<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    [class]="['agpr-switch-container', 'agpr-switch-container--' + style]"
    [style.padding]="padding + 'px'"
    (click)="click($event)"
    (keydown)="onKeydown($event)"
    [agprTooltip]="tooltip | localize"
    [attr.aria-describedby]="ariaDescribedBy"
    role="switch"
    [attr.aria-checked]="value"
    [initiallyFocusable]="initiallyFocusable"
    [id]="id + '_container'"
>
    <p-toggleswitch class="agpr-input-switch"
        [(ngModel)]="value"
        [disabled]="disabled"
        [tabindex]="-1"
    ></p-toggleswitch>
    <span
        *ngIf="onText"
        [ngClass]="{'agpr-switch-text' : true,
                    'agpr-switch-text-disabled' : !value, 'agpr-switch-text-enabled' : value}"
        [id]="id + '_value'"
    >
        {{value ? (onText | localize) : (offText | localize)}}
    </span>
    <span
        *ngIf="tooltip"
        [id]="id"
        class="u-srOnly"
    >
        {{ tooltip | localize }}
    </span>
</div>

<span
    *ngIf="isArchiveSearch"
    role="img"
    class="fa-regular fa-circle-info agpr-switch-infoIcon"
    [agprTooltip]="iconTooltip | localize"
    tooltipPosition="top"
    [id]="id + '_archiveSearch'"
></span>
